import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useSelectedOnBehalfOfUserId } from '../analyticsSettings/selectors';
import { useCanAccessCampaignsInsights } from '../campaignRights';
import { useExperimentTreatmentWithoutReporting } from '../experiments';

export const useIsCampaignsEntryPointVisible = (): boolean => {
  const isVivaEngagePremium = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;
  const hasCampaignAnalyticsAccess = useCanAccessCampaignsInsights();
  const selectedOnBehalfOfUserId = useSelectedOnBehalfOfUserId();
  const isLeaderSelectedOnBehalfOfViewer = !!selectedOnBehalfOfUserId;

  return isVivaEngagePremium && hasCampaignAnalyticsAccess && isLeaderSelectedOnBehalfOfViewer === false;
};
